import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Camera, Loader2, Trash2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const photoSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export default function RoomPhotosUploader({ room, onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const photos = room.photos || [];

  const upload = async (files) => {
    if (!files || files.length === 0) return;
    const fd = new FormData();
    [...files].forEach((f) => fd.append("files", f));
    setBusy(true);
    try {
      await api.post(`/rooms/${room.id}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${files.length} photo(s) ajoutée(s)`);
      onChange && onChange();
    } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi"); }
    finally { setBusy(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  const remove = async (url) => {
    try {
      await api.delete(`/rooms/${room.id}/photos`, { params: { url } });
      toast.success("Photo supprimée");
      onChange && onChange();
    } catch (e) { toast.error("Erreur"); }
  };

  return (
    <div className="mt-3" data-testid={`room-photos-${room.id}`}>
      <div className="grid grid-cols-3 gap-1.5">
        {photos.map((p) => (
          <div key={p} className="relative group aspect-square rounded-lg overflow-hidden bg-slate-100">
            <img src={photoSrc(p)} alt="" className="w-full h-full object-cover" />
            <button data-testid="delete-photo-btn" onClick={() => remove(p)} className="absolute top-1 right-1 bg-white/90 rounded-full p-1 text-rose-600 opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 className="w-3 h-3" /></button>
          </div>
        ))}
        <button data-testid={`upload-photo-btn-${room.id}`} disabled={busy} onClick={() => inputRef.current?.click()}
          className="aspect-square rounded-lg border-2 border-dashed border-slate-300 grid place-items-center text-slate-500 hover:border-emerald-500 hover:text-emerald-600 transition-colors disabled:opacity-50">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Camera className="w-5 h-5" />}
        </button>
      </div>
      <input ref={inputRef} data-testid={`upload-photo-input-${room.id}`} type="file" accept="image/*" multiple capture="environment" className="hidden" onChange={(e) => upload(e.target.files)} />
      <div className="mt-1 text-[11px] text-slate-500">{photos.length} photo(s) · JPG, PNG, WebP, HEIC (8 Mo max)</div>
    </div>
  );
}
